import { components } from "react-select"

const DropdownIndicatorForSelect = (props: any) => (
  <components.DropdownIndicator {...props} isFocused={false}>
    <div className="max-h-[20px] flex items-center">
      <i className="ri-arrow-down-s-line text-[20px] font-bold"></i>
      <i className="ri-information-line text-base text-red-500 mr-1"></i>
    </div>
  </components.DropdownIndicator>
)

export default DropdownIndicatorForSelect
